export const MaxMeteredServiceCodeLength = 3;
export const MaxMeteredServiceLegalCodeLength = 3;